<template>
  <CancelFlowRedesignExperiment>
    <template #default>
      <MembershipOverview/>
    </template>
    <template #redesign>
      <MembershipOverviewRedesign/>
    </template>
  </CancelFlowRedesignExperiment>
</template>
<script setup>
import CancelFlowRedesignExperiment from '@/components/account/membership/new/CancelFlowRedesignExperiment.vue'
import MembershipOverview from '@/components/account/membership/MembershipOverview.vue'
import MembershipOverviewRedesign from '@/views/account/MembershipOverview.vue'
</script>